const createLinkElementInDOM = (href, before) => {
    const linkNode = document.createElement('link');
    linkNode.type = 'text/css';
    linkNode.rel = 'stylesheet';
    linkNode.href = href;
    if (before) {
        document
            .getElementsByTagName('head')[0]
            .insertBefore(linkNode, document.getElementsByTagName('head')[0].firstChild);
    } else {
        document.getElementsByTagName('head')[0].appendChild(linkNode);
    }
};
export default createLinkElementInDOM